import type { FormatIntlType } from '../types';

export type ResolvedFormatIntlType = Exclude<FormatIntlType, 'relativeDateTime'>;

type P = {
  locale: string;
  type: ResolvedFormatIntlType;
};

const formatterOptions: Record<ResolvedFormatIntlType, Intl.DateTimeFormatOptions> = {
  date: {
    dateStyle: 'medium',
  },
  dateTime: {
    dateStyle: 'medium',
    timeStyle: 'short',
  },
  dayLong: {
    weekday: 'long',
  },
  dayNumber: {
    day: 'numeric',
  },
  dayNumberShortDay: {
    day: 'numeric',
    weekday: 'short',
  },
  dayShort: {
    weekday: 'short',
  },
  dayShortMonthDay: {
    day: 'numeric',
    month: 'short',
    weekday: 'short',
  },
  dayShortMonthDayYear: {
    day: 'numeric',
    month: 'short',
    weekday: 'short',
    year: 'numeric',
  },
  longMonth: {
    month: 'long',
  },
  monthYear: {
    month: 'long',
    year: 'numeric',
  },
  shortMonth: {
    month: 'short',
  },
  shortMonthDay: {
    day: 'numeric',
    month: 'short',
  },
  shortMonthDayYear: {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  },
  time: {
    timeStyle: 'short',
  },
};

export const getFormatter = ({ locale, type }: P) => new Intl.DateTimeFormat(locale, formatterOptions[type]);
